export function saveChangedPassword(newPass) {
  console.log('saveChangedPassword')
  window.androidApp.saveChangedPassword(newPass);
}

export function androidOpenUrlInBrowser(url) {
  window.androidApp.openUrlInBrowser(url);
}

export function openWhatsappAndroid(url) {
  window.androidApp.openWhatsapp(url);
}

export function openErrorPage(name, message){
  window.androidApp.openErrorPage(name, message)
}